import { styled, Box, DialogTitle, DialogContent, DialogActions } from "@mui/material";
import { shouldNotForwardProps } from "../../utils/shouldNotForwardProps.js";
const StyledDialogTitle = styled(Box)(({ theme }) => ({
  fontSize: "18px",
  lineHeight: "22px",
  fontWeight: 700,
  padding: "0 12px 0 18px",
  borderBottom: `1px solid ${theme.palette.secondary[300]}`,
  display: "flex",
  alignItems: "center",
  position: "relative",
  height: 48,
  margin: 0,
  flexShrink: 0,
  justifyContent: "space-between",
  [theme.breakpoints.up("sm")]: {
    padding: "0 12px 0 24px"
  }
}));
StyledDialogTitle.defaultProps = {
  component: DialogTitle
};
const StyledDialogContent = styled(DialogContent)(({ theme: t }) => ({
  padding: 18,
  fontSize: "14px",
  lineHeight: "24px",
  fontWeight: 400,
  textAlign: "center",
  [t.breakpoints.up("sm")]: {
    padding: "36px 24px"
  }
})), StyledDialogActions = styled(
  DialogActions,
  shouldNotForwardProps(["spaceBetween", "noBorder", "noStack"])
)(({
  spaceBetween,
  noStack,
  noBorder,
  theme: t
}) => ({
  justifyContent: spaceBetween || noStack ? "space-between!important" : "center!important",
  padding: 16,
  gap: 21,
  margin: 0,
  button: {
    margin: "0!important"
  },
  [t.breakpoints.up("xs")]: {
    borderTop: noBorder ? void 0 : `1px solid ${t.palette.border.base.elevation1 ?? ""}`
  },
  [t.breakpoints.only("xs")]: {
    ...!noStack && {
      gap: 12,
      flexDirection: "column-reverse",
      button: {
        width: "100%"
      }
    }
  },
  [t.breakpoints.up("sm")]: {
    padding: 24
  }
}));
export {
  StyledDialogActions,
  StyledDialogContent,
  StyledDialogTitle
};
//# sourceMappingURL=styles.js.map
